// SearchInput — JN5-0 header search field. Now a TRIGGER that opens the full
// Search modal (Paper V10-0). The live /v1/search query, results dropdown and
// address-paste navigation moved into SearchModal; this owns only the field
// affordance and the global "/" (and Ctrl/Cmd+/) shortcut to open it.

import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useEffect } from 'react'
import styles from './SearchInput.module.css'

function isTypingTarget(el: EventTarget | null): boolean {
  const node = el as HTMLElement | null
  if (!node) return false
  const tag = node.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || node.isContentEditable
}

export function SearchInput({ onOpen }: { onOpen: () => void }) {
  // "/" or Ctrl+/ / Cmd+/ → open the search modal (unless already typing in a
  // field). preventDefault so "/" doesn't open the browser's quick-find.
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key !== '/') return
      if (e.ctrlKey || e.metaKey || !isTypingTarget(e.target)) {
        e.preventDefault()
        onOpen()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onOpen])

  return (
    <button
      type="button"
      className={styles.field}
      onClick={onOpen}
      aria-haspopup="dialog"
      aria-label="Search tokens"
    >
      <MagnifyingGlassIcon size={18} weight="bold" className={styles.glyph} />
      <span className={styles.placeholder}>Search token, contract or wallet</span>
      <span className={styles.kbd} aria-hidden="true">
        <span>/</span>
      </span>
    </button>
  )
}
